import { Component, Input, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit {
  @Input() content = [];

  minHeight: any;

  constructor() {}

  ngOnInit() {
    this.content.forEach(item => this.setMinHeight(item.url));
    $(document.querySelector('#carouselIndicators')).carousel({
      interval: 5000,
    });
  }

  setMinHeight(url) {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      if (!this.minHeight) {
        this.minHeight = img.naturalHeight;
      }
      if (img.naturalHeight < this.minHeight) {
        this.minHeight = img.naturalHeight;
      }
    };
  }
}
